import * as React from 'react';
import ContentTile from './ContentTile';

export default () => (
  <ContentTile color="#0067F4">
    {/* A plug, as on Connections. */}
    <path d="M9 3v4M15 3v4M12 16v5" />
    <path d="M6 7h12v3a6 6 0 0 1-12 0V7Z" />
  </ContentTile>
);
